import { render, staticRenderFns } from "./SourceTypeBadge.vue?vue&type=template&id=ac0711ac&"
import script from "./SourceTypeBadge.vue?vue&type=script&lang=js&"
export * from "./SourceTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports